<clr-modal [(clrModalOpen)]="isModalOpen" [clrModalSize]="'full-screen'">
  <h3 class="modal-title">
    {{ 'Skizzenpunkte bearbeiten' | mrTranslate }}
  </h3>
  <div class="modal-body d-f col h-100 scroll-y">
    <div
      class="scroll-x min-h-min-c"
      [style.cursor]="
        currentMode() == 'none' ?
          isDragging() ? 'grabbing'
          : canBeDragged() ? 'grab'
          : 'inherit'
        : 'crosshair'
      ">
      <div #konvaContainer></div>
    </div>
    <form
      id="point-form"
      (ngSubmit)="saveIfValid()"
      clrForm
      [formGroup]="form"
      class="clr-form-full-width d-f gap-5 no-margin">
      <clr-control-container>
        <label class="clr-required-mark clr-col-12">{{ 'Zählerwert SA' | mrTranslate }}</label>
        <app-datalist-input [datalist]="zWerteCodes()" formControlName="Code" />
        <clr-control-error *clrIfError="'required'">
          {{ 'Erforderlich' | mrTranslate }}
        </clr-control-error>
      </clr-control-container>
      <fieldset class="border padding-9 d-f">
        <legend class="clr-control-label w-auto">
          {{ 'Startposition' | mrTranslate }}
          <button
            type="button"
            class="btn btn-icon btn-sm nm"
            (click)="currentMode.set('start')"
            [disabled]="currentMode() == 'start'">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="pencil" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Start bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </legend>
        <clr-number-input-container>
          <label class="clr-required-mark">x</label>
          <input type="number" clrNumberInput formControlName="X1" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-number-input-container>
        <clr-number-input-container>
          <label class="clr-required-mark">y</label>
          <input type="number" clrNumberInput formControlName="Y1" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-number-input-container>
      </fieldset>
      <fieldset class="border padding-9 d-f">
        <legend class="clr-control-label w-auto">
          {{ 'Endposition' | mrTranslate }}
          <button
            type="button"
            class="btn btn-icon btn-sm nm"
            (click)="currentMode.set('end')"
            [disabled]="currentMode() == 'end'">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="pencil" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Ende bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </legend>
        <clr-number-input-container>
          <label class="clr-required-mark">x</label>
          <input type="number" clrNumberInput formControlName="X2" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-number-input-container>
        <clr-number-input-container>
          <label class="clr-required-mark">y</label>
          <input type="number" clrNumberInput formControlName="Y2" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-number-input-container>
      </fieldset>
    </form>
    <div class="card d-f col" style="flex: 1 1 30%; min-height: 195px">
      <div class="card-header padding-9">
        <div class="btn-group btn-primary btn-icon margin-0-t">
          <button type="submit" form="point-form" class="btn btn-icon btn-success" [title]="'Speichern' | mrTranslate">
            <cds-icon shape="floppy" />
          </button>
          <button class="btn btn-icon" [title]="'Neu' | mrTranslate" (click)="selected.set([])">
            <cds-icon shape="plus" />
          </button>
          <button
            class="btn btn-icon btn-danger"
            [title]="'Löschen' | mrTranslate"
            (click)="deletePoint()"
            [disabled]="!selectedID()">
            <cds-icon shape="times" />
          </button>
        </div>
      </div>
      <div class="card-block padding-3-lr padding-1-t d-f col flex-1-1-auto" style="min-height: 155px">
        @if (isLoading()) {
          <clr-spinner class="centred" />
        } @else {
          <clr-datagrid
            class="datagrid-compact fill-space"
            [clrDgRowSelection]="true"
            [clrDgItemsIdentityFn]="row => row?.ID"
            [clrDgSelectionType]="'single'"
            [(clrDgSelected)]="selected">
            @for (column of table().columns; track column.id) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                  {{ column.id | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of table().rows; let i = index" [clrDgItem]="row">
              @for (cell of table().columns; track cell.id) {
                <clr-dg-cell class="name-cell">
                  {{ row[cell.id] | tablePrettyPrint }}
                </clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>
    </div>
  </div>
</clr-modal>
